import React from "react";

const STAR_COUNT = 42;

/**
 * Deterministic “random” star positions and blink timing (no Math.random)
 * so each dot turns on/off out of phase with the others.
 */
export default function GlobalStarOverlay() {
  return (
    <div className="app-global-background__starfield" aria-hidden="true">
      {Array.from({ length: STAR_COUNT }, (_, i) => {
        const left = ((i * 17 + 7) % 93) + 3;
        const top = ((i * 31 + 11) % 88) + 5;
        const delay = Number(
          (((i * 0.23) % 5) * 2.8 + (i % 3) * 0.45).toFixed(2)
        );
        // Long cycles so each dot fades in/out very slowly (~12–34s)
        const duration = Number(
          (12 + (i % 9) * 2.2 + (i % 2) * 1).toFixed(2)
        );
        const sizeClass =
          i % 7 === 0
            ? "app-global-background__star--lg"
            : i % 4 === 0
              ? "app-global-background__star--md"
              : "";

        return (
          <span
            key={i}
            className={`app-global-background__star ${sizeClass}`.trim()}
            style={{
              left: `${left}%`,
              top: `${top}%`,
              animationDelay: `${delay}s`,
              animationDuration: `${duration}s`,
            }}
          />
        );
      })}
    </div>
  );
}
